import React from "react";
import { Callout, CalloutVariant } from "./Callout";
import { makeStyles } from "@mui/styles";

const useClasses = makeStyles({
  tipboxContent: {
    margin: 0,
    padding: "5px 0 0 60px",
  },
});

type Props = {
  title?: string;
  className?: string;
  cardHeaderClassName?: string;
  children: React.ReactNode;
};
export const TipBox: React.FC<Props> = ({ title, children, className, cardHeaderClassName }) => {
  const classes = useClasses();
  return (
    <Callout
      title={title}
      icon={<img src="/assets/images/icon-lightbulb.svg" color="primary" width="28" />}
      variant={CalloutVariant.Purple}
      className={className}
      cardContentClassName={classes.tipboxContent}
      cardHeaderClassName={cardHeaderClassName ?? "pb-0"}
    >
      {children}
    </Callout>
  );
};
